import { ref, onMounted, onUnmounted } from 'vue';

export function useScrollUpReveal(offset = 50) {
    const isHidden = ref(false);
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
        const currentScrollY = window.scrollY;

        if (currentScrollY <= 500) {
            isHidden.value = false;
        } else {
            isHidden.value = currentScrollY > lastScrollY && currentScrollY > offset;
        }
        lastScrollY = currentScrollY;
    };

    onMounted(() => {
        window.addEventListener('scroll', handleScroll);
    });

    onUnmounted(() => {
        window.removeEventListener('scroll', handleScroll);
    });

    return { isHidden };
}
